import {types} from './types';

const setGetReplenishmentAction = (payload) => {
    return {
        type: types.SET_REPLENISHMENT,
        payload,
      }
}

export {
  setGetReplenishmentAction
}
